import * as types from '../types'

// get user from localStorage
const initialState = {
    loading: false,
    loginUser: {},
    loggedIn: false,
    error: null
}

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.LOGIN:
            return {
                ...state,
                loginUser: action.payload,
                loading: false,
                error: null
            }
        case types.LOG_OUT:
            return {
                ...state,
                loginUser: null,
                loggedIn: false,
                loading: false,
                error: null
            }
        case types.SET_LOADING:
            return {
                ...state,
                loading: true,
                error:null
            }
        case types.RESET_LOADING:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.SYNC_USER:
            return {
                ...state,
                loading: false,
                error: null
            }
        case types.RESET:
            return {
                ...state,
                loading: false,
                error:null
            }
        case types.SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state
    }
}